import { ref, watch } from 'vue';

// 顯示比例設定：乘在 html 的 vw root font-size 上（見 tailwind.css 的 --display-scale），
// 因為是純倍數，全站等比縮放不跑版的特性完全保留。
// 注意：105% 以上時，批價/藥品資料等高度較滿的視窗在較矮的瀏覽器視窗可能出現直向捲軸；
// 130% 在 16:9 視窗下批價需捲動約 1/5 才看得到底部按鈕，看診頁右側歷史病歷也會出現捲軸。
// 存 cookie 而非 localStorage：結束系統（exitProgram）會 localStorage.clear()，
// 存在 localStorage 每次重新登入都要重調
const STORAGE_KEY = 'displayScale';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 * 10; // 10 年
const SCALE_OPTIONS = [1, 1.05, 1.1, 1.2, 1.3];

const readCookie = () => {
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${STORAGE_KEY}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const writeCookie = (value) => {
  document.cookie = `${STORAGE_KEY}=${encodeURIComponent(value)}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
};

const readStored = () => {
  // 舊版存在 localStorage，沒有 cookie 時沿用一次
  const raw = readCookie() ?? localStorage.getItem(STORAGE_KEY);
  const v = parseFloat(raw);
  return SCALE_OPTIONS.includes(v) ? v : 1;
};

const scale = ref(readStored());

const apply = (value) => {
  document.documentElement.style.setProperty('--display-scale', value);
};

apply(scale.value);
writeCookie(String(scale.value));
localStorage.removeItem(STORAGE_KEY);

watch(scale, (v) => {
  writeCookie(String(v));
  apply(v);
});

// 開發模式 API 經 Vite proxy 與前端同源，後端登出回應會把這顆 cookie 一併清掉
// （實測回應無 Clear-Site-Data，推測是 Set-Cookie 逐一過期），
// 登出完成後由 exitProgram 以記憶體中的值重新寫回
export function persistDisplayScale() {
  writeCookie(String(scale.value));
}

export function useDisplayScale() {
  return { scale, options: SCALE_OPTIONS };
}
